module.exports = __webpack_public_path__ + "static/media/TN-Women-Skirts-2.0.12b4ebab.svg";